
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Star } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useUser } from '@/contexts/UserContext';

const EarlyAccessBanner: React.FC = () => {
  const { isAuthenticated } = useUser();
  const location = useLocation();

  // Hide banner for authenticated users
  if (isAuthenticated) {
    return null;
  }

  // Hide banner on homepage
  if (location.pathname === '/') {
    return null;
  }

  return (
    <div className="bg-terracotta text-cream py-3 px-4 relative">
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 text-center">
        <div className="flex items-center justify-center gap-2">
          <Star className="h-4 w-4 fill-golden text-golden flex-shrink-0" />
          <span className="text-sm font-medium whitespace-nowrap">
            <span className="hidden sm:inline">forkast is in early beta — get a spot now!</span>
            <span className="sm:hidden">Early beta — Get a spot!</span>
          </span>
        </div>
        
        <a 
          href="https://twitter.com/forkastapp" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          <Button 
            variant="outline" 
            size="sm" 
            className="bg-transparent border-cream text-cream hover:bg-cream hover:text-terracotta text-xs md:text-base px-3 py-1 whitespace-nowrap"
          >
            Follow Updates
          </Button>
        </a>
      </div>
    </div>
  );
};

export default EarlyAccessBanner;
